import { BadgeOption } from 'src/types';
import { ICON_MAP } from 'src/utils/constants';
import { PLAN_CHANGE_STATUS, SUBSCRIPTION_STATUS, TRIAL_MODE } from 'src/features/subscriptions/utils/types';
import { subscriptionsMessages } from 'src/features/subscriptions/utils/messages';

export const SUBSCRIPTIONS_STATUS_BADGE_OPTIONS: Record<SUBSCRIPTION_STATUS, BadgeOption> = {
    [SUBSCRIPTION_STATUS.ACTIVE]: {
        label: subscriptionsMessages.active,
        theme: 'green',
        icon: ICON_MAP.CHECK,
    },
    [SUBSCRIPTION_STATUS.TRIALING]: {
        label: subscriptionsMessages.trialing,
        theme: 'blue',
        icon: ICON_MAP.SCHEDULED,
    },
    [SUBSCRIPTION_STATUS.CANCELLED]: {
        label: subscriptionsMessages.cancelled,
        theme: 'red',
        icon: ICON_MAP.X_MARK,
    },
    [SUBSCRIPTION_STATUS.ENDED]: {
        label: subscriptionsMessages.endedSubscription,
        theme: 'gray',
        icon: ICON_MAP.PAST,
    },
    [SUBSCRIPTION_STATUS.FROZEN]: {
        label: subscriptionsMessages.frozen,
        theme: 'blue',
        icon: ICON_MAP.FROZEN,
    },
};

export const PLAN_CHANGE_STATUS_BADGE_OPTIONS: Record<PLAN_CHANGE_STATUS, BadgeOption> = {
    [PLAN_CHANGE_STATUS.SCHEDULED]: {
        label: subscriptionsMessages.planChangeScheduled,
        theme: 'orange',
        icon: ICON_MAP.SCHEDULED,
    },
    [PLAN_CHANGE_STATUS.APPLIED]: {
        label: subscriptionsMessages.planChangeApplied,
        theme: 'green',
        icon: ICON_MAP.CHECK,
    },
    [PLAN_CHANGE_STATUS.CANCELLED]: {
        label: subscriptionsMessages.planChangeCancelled,
        theme: 'red',
        icon: ICON_MAP.X_MARK,
    },
    [PLAN_CHANGE_STATUS.FAILED]: {
        label: subscriptionsMessages.planChangeFailed,
        theme: 'red',
        icon: ICON_MAP.DANGER,
    },
};

export const TRIAL_MODE_MAP: Record<TRIAL_MODE, { id: string; defaultMessage: string }> = {
    [TRIAL_MODE.PLAN_DEFAULT]: subscriptionsMessages.trialPlanDefault,
    [TRIAL_MODE.NONE]: subscriptionsMessages.trialNone,
    [TRIAL_MODE.CUSTOM]: subscriptionsMessages.trialCustom,
};
